import { render, staticRenderFns } from "./CandC-Cutting.vue?vue&type=template&id=15d96b42"
import script from "./CandC-Cutting.vue?vue&type=script&lang=js"
export * from "./CandC-Cutting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports